import React, {useState} from "react";
import Burger from '../Hamburger.js'
import MobileNavBar from '../MobileNavBar.js'
import '../Desktop.css'

import Book from '../../Images/Design/PenguinBooks/AllYouHavetoDo.jpg'



function AllYouHavetoDo(){
	const [open, setOpen] = useState(false);

	return(
		<div class="page">
		    <div class="designContentPageBook">
		    	<div className="mobileNav">
					<Burger open={open} setOpen={setOpen}/>
					<MobileNavBar open={open} setOpen={setOpen}/>
				</div>
		        <div class="contentHMH">
		            <img class="contentImage" src={Book} />
		            <p class="contentTextHMHTitle">All You Have to Do</p>
		            <p class="contentTextHMH">Penguin Young Readers</p>
		            <p class="contentTextHMH ItalicText" >Art direction, design</p>
		            <br />
		            <p class="contentTextHMH2 ItalicText" >"Cover photos: 
Columbia U Students Protest War by John Duricka © Associated Press; 
On the Pulse of Morning, Million Man March, October 16, 1996 
by Roderick Terry © Roderick Terry; 
2 boys © Author’s personal photo collection"</p>
		        </div>
		    </div>
		</div>
	)
}

export default AllYouHavetoDo